import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || 'en';

  const change = (lang) => {
    if (lang === current) return;
    i18n.changeLanguage(lang);
  };

  return (
    <div
      className="inline-flex items-center gap-1 border border-maroon/20 rounded-full overflow-hidden text-xs font-semibold"
      data-testid="language-switcher"
    >
      <Globe size={14} className="ml-2 mr-1 text-maroon/50" aria-hidden />
      <button
        type="button"
        onClick={() => change('en')}
        className={`px-2.5 py-1 transition-colors ${current === 'en' ? 'bg-maroon text-cream' : 'text-maroon hover:bg-maroon/10'}`}
        aria-pressed={current === 'en'}
        data-testid="lang-en-btn"
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => change('es')}
        className={`px-2.5 py-1 transition-colors ${current === 'es' ? 'bg-maroon text-cream' : 'text-maroon hover:bg-maroon/10'}`}
        aria-pressed={current === 'es'}
        data-testid="lang-es-btn"
      >
        ES
      </button>
    </div>
  );
};

export default LanguageSwitcher;
